






































































import { Component, Vue, Watch } from 'vue-property-decorator';
import Staff from '@/services/Staff';
import { Policy, StaffPolicyData } from '@/common/Policy';
import { AxiosResponse } from 'axios';

import Welcome from '@/components/Global/Welcome.vue';
import Alert from '@/components/Global/Alert.vue';
import Loading from '@/components/Global/Loading.vue';

import Sidebar from '@/components/Staff/ManagePolicy/Sidebar.vue';
import Risks from '@/components/Staff/ManagePolicy/Risks.vue';
import Accounting from '@/components/Staff/ManagePolicy/Accounting.vue';
import Users from '@/components/Staff/ManagePolicy/Users.vue';
import Management from '@/components/Staff/ManagePolicy/Management.vue';

@Component({
	components: {
		Welcome,
		Alert,
		Loading,
		Sidebar,
		Risks,
		Accounting,
		Users,
		Management,
	},
})
export default class ManagePolicy extends Vue {
	private loading: boolean = true;
	private error: boolean = false;
	private refreshSuccess = false;
	private refreshError = false;
	private deletePolicyError = false;
	private policyData: Policy;
	private currentTab: string = 'risks';

	@Watch('$route', { deep: true })
	private watchRoute(newValue) {
		this.currentTab = this.$route.params.tab;
	}

	private tab(tab) {
		this.currentTab = tab;
	}

	private refreshPolicy() {
		this.refreshError = false;
		this.refreshSuccess = false;

		Staff.updatePolicy({
			cmd: 'refreshPolicies',
			product_ids: [this.policyData.product_id],
		})
			.then(({ data }: AxiosResponse) => (this.refreshSuccess = true))
			.catch(() => (this.refreshError = true));
	}

	private created() {
		Staff.getPolicy(this.$route.params.product_id)
			.then(({ data }: AxiosResponse<Policy>) => {
				this.policyData = data;
			})
			.catch(e => {
				this.error = true;
			})
			.finally(() => (this.loading = false));
	}

	private async deletePolicy() {
		this.deletePolicyError = false;
		if (
			!confirm(
				"Are you sure you want to delete the policy from the products table? This won't delete it from any user.",
			)
		) {
			return;
		}

		try {
			const deletePolicy = await Staff.updatePolicy({
				cmd: 'deletePolicy',
				product_ids: [this.policyData.product_id],
			});

			this.$router.push({
				name: 'staffpolicies',
			});
		} catch (e) {
			console.log(e);
			this.deletePolicyError = true;
		}
	}
}
